import { ThemeIcon } from "@mantine/core";
import Pause from "./icon-svg/Pause.svg?react";
import Documents from "./icon-svg/Documents.svg?react";
import Email from "./icon-svg/Email.svg?react";
import Link from "./icon-svg/Link.svg?react";
import Archive from "./icon-svg/Archive.svg?react";
import PeopleAdd from "./icon-svg/PeopleAdd.svg?react";
import PeopleCommunity from "./icon-svg/PeopleCommunity.svg?react";
import Star from "./icon-svg/Star.svg?react";
import StarFilled from "./icon-svg/StarFilled.svg?react";
import Play from "./icon-svg/Play.svg?react";
import Key from "./icon-svg/Key.svg?react";
import ExternalLink from "./icon-svg/ExternalLink.svg?react";
import Notification from "./icon-svg/Notification.svg?react";
import Question from "./icon-svg/Question.svg?react";
import CalendarStar from "./icon-svg/CalendarStar.svg?react";

function Wrapper({ children, ...props }) {
  return (
    <ThemeIcon variant="subtle" {...props}>
      {children}
    </ThemeIcon>
  );
}

export function PauseIcon({ size, iconSize, style, variant, color, ...props }) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <Pause width={iconSize} />
    </Wrapper>
  );
}
export function DocumentsIcon({
  size,
  iconSize,
  style,
  variant,
  color,
  ...props
}) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <Documents width={iconSize} />
    </Wrapper>
  );
}
export function EmailIcon({ size, iconSize, style, variant, color, ...props }) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <Email width={iconSize} />
    </Wrapper>
  );
}
export function LinkIcon({ size, iconSize, style, variant, color, ...props }) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <Link width={iconSize} />
    </Wrapper>
  );
}
export function ArchiveIcon({
  size,
  iconSize,
  style,
  variant,
  color,
  ...props
}) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <Archive width={iconSize} />
    </Wrapper>
  );
}
export function PeopleAddIcon({
  size,
  iconSize,
  style,
  variant,
  color,
  ...props
}) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <PeopleAdd width={iconSize} />
    </Wrapper>
  );
}
export function PeopleCommunityIcon({
  size,
  iconSize,
  style,
  variant,
  color,
  ...props
}) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <PeopleCommunity width={iconSize} />
    </Wrapper>
  );
}
export function PlayIcon({ size, iconSize, style, variant, color, ...props }) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <Play width={iconSize} />
    </Wrapper>
  );
}
export function StarFilledIcon({
  size,
  iconSize,
  style,
  variant,
  color,
  ...props
}) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <StarFilled width={iconSize} />
    </Wrapper>
  );
}
export function StarIcon({ size, iconSize, style, variant, color, ...props }) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <Star width={iconSize} />
    </Wrapper>
  );
}
export function KeyIcon({ size, iconSize, style, variant, color, ...props }) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <Key width={iconSize} />
    </Wrapper>
  );
}
export function ExternalLinkIcon({
  size,
  iconSize,
  style,
  variant,
  color,
  ...props
}) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <ExternalLink width={iconSize} />
    </Wrapper>
  );
}
export function NotificationIcon({
  size,
  iconSize,
  style,
  variant,
  color,
  ...props
}) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <Notification width={iconSize} />
    </Wrapper>
  );
}

export function QuestionIcon({
  size,
  iconSize,
  style,
  variant,
  color,
  ...props
}) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <Question width={iconSize} />
    </Wrapper>
  );
}
export function CalendarStarIcon({
  size,
  iconSize,
  style,
  variant,
  color,
  ...props
}) {
  return (
    <Wrapper
      size={size}
      style={style}
      variant={variant}
      color={color}
      {...props}
    >
      <CalendarStar width={iconSize} />
    </Wrapper>
  );
}
